/** Backend API message when editing info or updating alert triggers against a stale inactive sample point. */
export function isInactiveSamplePointErrorMessage(message: string): boolean {
  return /^SamplePoint with id \d+ is inactive$/.test(message);
}
